import { useState } from 'react';

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);

  return (
    <a
      href="https://wa.me/525534748982?text=Hola,%20me%20gustaría%20agendar%20una%20cita%20en%20MF%20Dental"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-8 right-8 z-50 flex items-center gap-3 cursor-pointer group"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      aria-label="Contactar por WhatsApp"
    >
      {/* Tooltip */}
      <div
        className={`bg-[#0A2540] text-white text-sm font-medium px-4 py-2 rounded-full whitespace-nowrap transition-all duration-300 shadow-lg ${
          hovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4 pointer-events-none'
        }`}
      >
        Escríbenos ahora
      </div>

      {/* Button */}
      <div className="relative w-14 h-14 flex items-center justify-center bg-[#25D366] hover:bg-[#128C7E] rounded-full shadow-[0_8px_30px_rgba(37,211,102,0.45)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(37,211,102,0.5)]">
        {/* Pulse ring */}
        <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
        <i className="ri-whatsapp-line text-white text-2xl" />
      </div>
    </a>
  );
}
